module.exports = __webpack_public_path__ + "img/GradeIcon.7f20e5da.svg";